import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import App from "../app.jsx";
import ProtectedRoute from "../components/protected-route/protected-route.jsx";
import ExtraError from "../pages/extra/extra-error.js";
import ExtraErrorOutside from "../pages/extra/extra-error-outside.js";
import ExtraComingSoon from "../pages/extra/extra-coming-soon.js";
import Dashboard from "../pages/dashboard/dashboard.js";
import Login from "../pages/user/login.js";
import RegisterV3 from "../pages/user/register-v3.js";
import ModelMapping from "../pages/model-mapping/model-mapping.js";
import EvacuationPortal from "../pages/evacuation-portal/evacuation-portal.js";
import EvacuationEvent from "../pages/evacuation-portal/evacuation-events.js";
import EvacuationOrder from "../pages/evacuation-portal/evacuation-orders.js";
import EvacuationOrderReport from "../pages/evacuation-portal/evacuation-order-report.js";
import DashboardDocumentation from "../pages/documentation/dashboard-documentation.js";
import ModellingDocumentation from "../pages/documentation/modelling-documentation.js";
import EvacuationDocumentation from "../pages/documentation/evacuation-documentation.js";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "dashboard-panels/*",
        element: (
          <ProtectedRoute requiredPermissions={["dashboard"]}>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "dashboard",
            element: <Dashboard />,
          },
          {
            path: "*",
            element: <ExtraError />,
          },
        ],
      },
      {
        path: "congestion-panels/*",
        element: (
          <ProtectedRoute requiredPermissions={["congestion-map", "vtmc", "batch-export"]} requireAll={false}>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          // Add your congestion routes here when ready
          {
            path: "*",
            element: <ExtraError />,
          },
        ],
      },
      {
        path: "model-mapping-panels/*",
        element: (
          <ProtectedRoute requiredPermissions={["model-mapping"]}>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "model-mapping",
            element: <ModelMapping />,
          },
        ],
      },
      {
        path: "evacuation-portal-panels/*",
        element: (
          <ProtectedRoute requiredPermissions={["evacuation-portal"]}>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "evacuation-portal",
            element: <EvacuationPortal />,
          },
          {
            path: "evacuation-order-report",
            element: <EvacuationOrderReport />,
          },
          {
            path: "evacuation-events",
            element: <EvacuationEvent />,
          },
          {
            path: "evacuation-orders",
            element: <EvacuationOrder />,
          },
          {
            path: "evacuation-dashboard",
            element: <ExtraComingSoon />,
          },
          {
            path: "evacuation-settings",
            element: <ExtraComingSoon />,
          },
        ],
      },
      {
        path: "documentation/*",
        element: (
          <ProtectedRoute requiredPermissions={["documentation"]}>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "dashboard-documentation",
            element: <DashboardDocumentation />,
          },
          {
            path: "modelling-documentation",
            element: <ModellingDocumentation />,
          },
          {
            path: "evacuation-documentation",
            element: <EvacuationDocumentation />,
          },
          {
            path: "*",
            element: <ExtraError />,
          },
        ],
      },
      {
        path: "resources-links",
        element: (
          <ProtectedRoute requiredPermissions={["resources-links"]}>
            <ExtraComingSoon />
          </ProtectedRoute>
        ),
      },
      {
        path: "contacts",
        element: (
          <ProtectedRoute requiredPermissions={["contacts"]}>
            <ExtraComingSoon />
          </ProtectedRoute>
        ),
      },
      // Public routes - not wrapped in ProtectedRoute
      {
        path: 'user/*',
        element: <Outlet />,
        children: [
          { path: 'login', element: <Login /> },
          { path: 'register-v3', element: <RegisterV3 /> },
          { path: '*', element: <ExtraError /> }
        ]
      },
      { path: "*", element: <ExtraErrorOutside /> },
    ],
  },
];

export default AppRoute;